module.exports = __webpack_public_path__ + "static/media/logo_samen_altijd_dark.8c15ed1a.png";